export function CanonicalWeightHint({
  canonicalWeight,
  weightDeviatesFromCanonical,
  weight,
}: {
  canonicalWeight: number | null;
  weightDeviatesFromCanonical: boolean;
  weight: number | null | undefined;
}) {
  if (canonicalWeight == null) return null;

  return (
    <>
      <p className="mt-1 text-xs text-zinc-500">
        Typical weight for this product: ~{canonicalWeight}kg
      </p>
      {weightDeviatesFromCanonical && weight != null ? (
        <p className="mt-1 text-xs text-amber-600">
          This looks unusually {weight > canonicalWeight ? "high" : "low"} —
          similar products typically weigh ~{canonicalWeight}kg.
        </p>
      ) : null}
    </>
  );
}
